/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_HelpInputs */



/**
* | output |
* | --- |
* | "Help" |
*
* @param {Nav_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const nav_help = /** @type {((inputs?: Nav_HelpInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_HelpInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Aide")
	if (locale === "es") return /** @type {LocalizedString} */ ("Ayuda")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Ajuda")
	if (locale === "it") return /** @type {LocalizedString} */ ("Guida")
	return /** @type {LocalizedString} */ ("Help")
});